import React from "react";

class Email extends React.Component {

    constructor() {
        super();

        this.state = {
            show: false
        };
    }

    onClick() {
        setTimeout(() => this.setState({ show: true }), 100);
    };

    componentDidMount(): void {
        setTimeout(() => { this.onClick(); }, 300);
    }

    render() {
        return (
            <span>
            {!this.state.show && <a onClick={() => this.onClick()}>Show email</a>}
            {this.state.show && <a href={'mailto:viktor.m@new-tab.studio'}>viktor.m@new-tab.studio</a>}
        </span>
        );
    }
}

export default Email;